import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { history } from '../../_helpers';

// @material-ui/core
import GridItem from "../../modules/Grid/GridItem.jsx";
import GridContainer from "../../modules/Grid/GridContainer.jsx";
import Danger from "../../modules/Typography/Danger.jsx";
import Card from "../../modules/Card/Card.jsx";
import CardHeader from "../../modules/Card/CardHeader.jsx";
import CardIcon from "../../modules/Card/CardIcon.jsx";
import CardFooter from "../../modules/Card/CardFooter.jsx";
import dashboardStyle from "../../modules/jss/dashboardStyle.jsx";

import withStyles from "@material-ui/core/styles/withStyles";
import Typography from '@material-ui/core/Typography';
import Store from "@material-ui/icons/Store";
import Warning from "@material-ui/icons/Warning";
import DateRange from "@material-ui/icons/DateRange";
import LocalOffer from "@material-ui/icons/LocalOffer";
import AccessAlarm from "@material-ui/icons/AccessAlarm";
import Backup from "@material-ui/icons/Backup";
import Update from "@material-ui/icons/Update";
import Accessibility from "@material-ui/icons/Accessibility";

import { tasksissuesActions, timesheetActions, projectActions } from '../../_actions';
import { connect } from 'react-redux';
import { compose } from "recompose";

import TasksIssuesFormComponent from '../TasksIssues/FormComponent';
import TasksIssuesEnhancedTable from '../TasksIssues/EnhancedTable';
import TasksIssuesReadOnlyFormComponent from '../TasksIssues/ReadOnlyFormComponent';

import TimesheetFormComponentTW from '../Timesheet/FormComponentTW';
import TimesheetFormComponent from '../Timesheet/FormComponent';
import TimesheetEnhancedTable from '../Timesheet/EnhancedTable';
import TimesheetEnhancedTableTW from '../Timesheet/EnhancedTableTW';
import TimesheetReadOnlyFormComponent from '../Timesheet/ReadOnlyFormComponent';

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            openReadOnly: false,
            taskId: '',
            timesheetId: '',

            timesheetTableOpen: false,
            readOnlyTimesheetTableOpen: false,
        };
    }

    componentDidMount() {
        this.props.dispatch(tasksissuesActions.getAllByProjectId(this.props.ProjectId));
        this.props.dispatch(timesheetActions.getAllByProjectId(this.props.ProjectId));
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.tasksissues.items !== this.props.tasksissues.items) {
            this.props.dispatch(projectActions.getAllByUserId(nextProps.user.id));
        }
    }

    handleEditTable = (EditData) => {
        this.setState({
            open: true,
            taskId: EditData.id
        })
    }

    handleDeleteTable = (DeleteData) => {
        this.props.dispatch(tasksissuesActions.delete(DeleteData));
        //alert('TBD')
    }

    handleReturnClick() {
        history.push('/Projects/');
    }

    handleOpen = () => {
        this.setState({
            open: true,
        });
    };

    handleClose = () => {
        this.clearAllFormTable()
        this.setState({
            mode: 'ADD',
            modalTitle: 'Create Project Task',
        });
    }

    handleReadOnlyTable = (DetailData) => {
        this.setState({
            openReadOnly: true,
            taskId: DetailData.id,
        })
    }

    handleReadOnlyClose = () => {
        this.setState({
            openReadOnly: false
        })
    }

    handleTimesheetTableClose = () => {
        this.clearAllFormTable()
        this.setState({
            mode: 'ADD',
            modalTitle: 'Create Timesheet',
        })
    }

    clearAllFormTable = () => {
        this.setState({
            open: false,
            timesheetTableOpen: false,
            openProgress: false,
            projectId: '',
            timesheetId: '',
            hours: '',
            taskId: '',
            taskName: '',
            taskNotes: '',
            subCategoryId: '',
            value: 3, //satisfaction

            dateValid: true,
            hoursValid: true,
            subCategoryIdValid: true,
            taskNotesValid: true,
        })
    }

    handleEditTimesheetTable = (DetailData) => {
        this.setState({
            timesheetId: DetailData.id,
            timesheetTableOpen: true
        })
    }

    handleDuplicateTimesheetTable = (DuplicateData) => {
        console.log('DuplicateData', DuplicateData)
        const DataProcessing = async () => {
            try {
                await this.props.dispatch(timesheetActions.duplicate(DuplicateData));
                await this.props.dispatch(timesheetActions.getAllByProjectId(this.props.ProjectId));
            } catch (e) {
                console.error("Problem", e)
            }
        }

        DataProcessing();
        //alert('TBD')
    }

    handleDeleteTimesheetTable = (DeleteData) => {
        console.log('DeleteData timesheet', DeleteData)
        this.props.dispatch(timesheetActions.delete(DeleteData));
        //alert('TBD')
    }

    handleTimesheetOpen = () => {
        this.setState({
            timesheetTableOpen: true
        })
    }

    handleReadOnlyTimesheetTable = (DetailData) => {
        this.setState({
            timesheetId: DetailData.id,
            readOnlyTimesheetTableOpen: true
        })
    }

    handleReadOnlyTimesheetClose = () => {
        this.setState({
            readOnlyTimesheetTableOpen: false
        })
    }

    handleCreateTimesheetClick = (EditData) => {
        this.setState({
            timesheetTableOpen: true,
            taskId: EditData[0],
            projectId: this.props.ProjectId,
        })
    }

    render() {
        const { classes, user, projects, tasksissues, timesheet } = this.props;

        const projectData = projectDataProcessing(projects.items, this.props.ProjectId);
        const completedPercent = projectData.CompletedPerent;
        const projectDuration = Number(projectDurationCount(timesheet.items, this.props.ProjectId));
        const projectManDay = projectManDayCount(tasksissues.items, this.props.ProjectId);

        return (
            <div>
                <Typography variant="h5" noWrap>
                    {projectData.ProjectId} - {projectData.CompanyName} - {projectData.ProjectName}
                </Typography>
                <GridContainer>
                    <GridItem xs={12} sm={6} md={3}>
                        <Card>
                            <CardHeader color="warning" stats icon>
                                <CardIcon color="warning">
                                    <AccessAlarm />
                                </CardIcon>
                                <p className={classes.cardCategory}>Man-Day</p>
                                <h1 className={classes.cardTitle}>{projectManDay}</h1>
                            </CardHeader>
                            <CardFooter stats>
                                <div className={classes.stats}>
                                    <Danger>
                                        <Warning />
                                    </Danger>
                                </div>
                            </CardFooter>
                        </Card>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={3}>
                        <Card>
                            <CardHeader color="success" stats icon>
                                <CardIcon color="success">
                                    <Store />
                                </CardIcon>
                                <p className={classes.cardCategory}>Actual Man-Day</p>
                                <h1 className={classes.cardTitle}>{projectDuration}</h1>
                            </CardHeader>
                            <CardFooter stats>
                                <div className={classes.stats}>
                                    <DateRange /> Last 24 Hours
                                </div>
                            </CardFooter>
                        </Card>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={3}>
                        <Card>
                            <CardHeader color="danger" stats icon>
                                <CardIcon color="danger">
                                    <Backup />
                                </CardIcon>
                                <p className={classes.cardCategory}>Completed Percent</p>
                                <h1 className={classes.cardTitle}>{Number(completedPercent)} %</h1>
                            </CardHeader>
                            <CardFooter stats>
                                <div className={classes.stats}>
                                    <LocalOffer /> Tracked from Hunter Game
                                </div>
                            </CardFooter>
                        </Card>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={3}>
                        <Card>
                            <CardHeader color="info" stats icon>
                                <CardIcon color="info">
                                    <Accessibility />
                                </CardIcon>
                                <p className={classes.cardCategory}>Man-Day Achieving Rate</p>
                                <h1 className={classes.cardTitle}>{Number((projectDuration / projectManDay * 100).toFixed(0))} %</h1>
                            </CardHeader>
                            <CardFooter stats>
                                <div className={classes.stats}>
                                    <Update /> Just Updated
                                </div>
                            </CardFooter>
                        </Card>
                    </GridItem>
                </GridContainer>

                <TasksIssuesEnhancedTable
                    handleEditTable={this.handleEditTable}
                    handleDeleteTable={this.handleDeleteTable}
                    handleOpen={this.handleOpen}
                    handleReadOnlyTable={this.handleReadOnlyTable}
                    handleCreateTimesheetClick={this.handleCreateTimesheetClick}
                    Pagename='Project'
                    ProjectId={this.props.ProjectId}
                    OwnerUserId={user.id}
                />

                <TasksIssuesFormComponent
                    open={this.state.open}
                    close={this.handleClose}
                    TaskId={this.state.taskId}
                    ProjectId={this.props.ProjectId}
                    Pagename='Project'
                />

                <TasksIssuesReadOnlyFormComponent
                    open={this.state.openReadOnly}
                    close={this.handleReadOnlyClose}
                    TaskId={this.state.taskId}
                    Pagename='Project'
                />

                {
                    user.departmentLocate === 'TW' ?
                        <TimesheetEnhancedTableTW
                            handleEditTable={this.handleEditTimesheetTable}
                            handleReadOnlyTable={this.handleReadOnlyTimesheetTable}
                            handleDeleteTable={this.handleDeleteTimesheetTable}
                            handleDuplicateTable={this.handleDuplicateTimesheetTable}
                            handleOpen={this.handleTimesheetOpen}
                            OwnerUserId={user.id}
                            handleCsvUpload={this.handleCsvUpload}
                            Pagename='Project'
                            ProjectId={this.props.ProjectId}
                        />
                        :
                        <TimesheetEnhancedTable
                            handleEditTable={this.handleEditTimesheetTable}
                            handleReadOnlyTable={this.handleReadOnlyTimesheetTable}
                            handleDeleteTable={this.handleDeleteTimesheetTable}
                            handleDuplicateTable={this.handleDuplicateTimesheetTable}
                            handleOpen={this.handleTimesheetOpen}
                            OwnerUserId={user.id}
                            Pagename='Project'
                            ProjectId={this.props.ProjectId}
                        />
                }

                {
                    user.departmentLocate === 'TW' ?
                        <TimesheetFormComponentTW
                            open={this.state.timesheetTableOpen}
                            close={this.handleTimesheetTableClose}
                            TaskId={this.state.taskId}
                            TimesheetId={this.state.timesheetId}
                            ProjectId={projectData.ProjectId}
                            Pagename='Project'
                        /> :
                        <TimesheetFormComponent
                            open={this.state.timesheetTableOpen}
                            close={this.handleTimesheetTableClose}
                            TaskId={this.state.taskId}
                            TimesheetId={this.state.timesheetId}
                            ProjectId={projectData.ProjectId}
                            Pagename='Project'
                        />
                }

                <TimesheetReadOnlyFormComponent
                    open={this.state.readOnlyTimesheetTableOpen}
                    close={this.handleReadOnlyTimesheetClose}
                    TimesheetId={this.state.timesheetId}
                />
            </div>
        );
    }
}

function projectDurationCount(data, ProjectId) {
    var duration = 0;
    data && data.map(element => {
        if (element.ProjectId === Number(ProjectId)) {
            duration += Number(element.Hours);
        }
        return null
    })

    return (duration / 8).toFixed(3)
}

function projectManDayCount(data, ProjectId) {
    var manDay = 0;
    data && data.map(element => {
        if (element.ProjectId === Number(ProjectId)) {
            manDay += Number(element.Duration);
        }
        return null
    })

    return manDay
}

function projectDataProcessing(data, ProjectId) {
    const projectData = data ? data.find(function (item) {
        return item.ProjectId === Number(ProjectId)
    }) : [];

    return projectData
}

function mapStateToProps(state) {
    const { user } = state.authentication;
    const { projects, tasksissues, timesheet } = state;

    return {
        user,
        projects,
        tasksissues,
        timesheet
    };
}

App.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default compose(connect(mapStateToProps), withStyles(dashboardStyle))(App);



// WEBPACK FOOTER //
// ./src/components/Project/App.js